import { defineComponent as _defineComponent } from 'vue'
import UserNavigation from "../../AdminNavigationContainer.vue";
import { ref, onMounted, reactive, onUpdated } from "vue";
import UserListDataService from "@/services/UserListDataService";
import { useI18n } from "vue3-i18n";
import ResponseData from "@/types/ResponseData";
import Loading from "@/components/home/Loading";
import Alert from "@/components/scan/parts/Alert.vue";
import { store } from "@/store/store";
import UserInfoDataService from "@/services/UserInfoDataService";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const isLoading = ref(false);
const alertMessage = ref("null");
const alertState = ref("neutral");
const i18n = useI18n();
const title = ref("User Information");
const userId = ref("");
const userinfoList = reactive([]);
const destinationList = reactive([]);
const targetStationCode = ref("");
const targetEmail = ref("");
const emailError = ref("");
const isAuthForLogin = ref(false); 

/** 初期表示設定 */
onMounted(function () {
  isLoading.value = true;
  userId.value = store.getters.userId;
  getUserInformation();
});

/** ユーザー情報取得 */
const getUserInformation = () => {
  alertMessage.value = "null";
  alertState.value = "neutral";
  isLoading.value = true;
  userinfoList.splice(0);
  const param = {
    userId: userId.value,
    loginUserId: store.getters.cognitoUserName
  };

  UserListDataService.getUserInformation(param)
    .then((response: ResponseData) => {
      if (response.data != undefined) {
        if(response.data.loginAdminObjList.length > 0){
          isAuthForLogin.value = true;
        }
        for (let info of response.data.userObjList) {
          var createdDate;
          var updatedDate;
          var lastAccessDate;
          if (info.createdDate != null) {
            createdDate = new Date(info.createdDate);
            info.createdDate =
              createdDate.getFullYear() +
              "/" +
              (createdDate.getMonth() + 1) +
              "/" +
              createdDate.getDate();
          }
          if (info.updatedDate != null) {
            updatedDate = new Date(info.updatedDate);
            info.updatedDate =
              updatedDate.getFullYear() +
              "/" +
              (updatedDate.getMonth() + 1) +
              "/" +
              updatedDate.getDate() +
              " " +
              updatedDate.getHours() +
              ":" +
              updatedDate.getMinutes() +
              ":" +
              updatedDate.getSeconds();
          }
          if (info.lastAccessDate != null) {
            lastAccessDate = new Date(info.lastAccessDate);
            info.lastAccessDate =
              lastAccessDate.getFullYear() +
              "/" +
              (lastAccessDate.getMonth() + 1) +
              "/" +
              lastAccessDate.getDate() +
              " " +
              lastAccessDate.getHours() +
              ":" +
              lastAccessDate.getMinutes() +
              ":" +
              lastAccessDate.getSeconds();
          }
          targetEmail.value = info.email;
          targetStationCode.value = info.stationcode;
          userinfoList.push(info);
          // ステーションコードの設定
          var storeDestList = [];
          if (param.userId.length != 6) {
            destinationList.splice(0);
            storeDestList = store.getters.stationListData;
            storeDestList.forEach((stObj) => {
              if (stObj.parentCode == info.parentCode) {
                destinationList.push(stObj);
              }
            });
          }else{
            destinationList.splice(0);
            storeDestList = store.getters.stationListData;
            storeDestList.forEach((stObj) => {
              destinationList.push(stObj);
            });
          }
        }
      } else {
        alertMessage.value = i18n.t("err012");
        alertState.value = "error";
      }
      isLoading.value = false;
    })
    .catch((e: Error) => {
      console.log(e);
      alertMessage.value = i18n.t("err012");
      alertState.value = "error";
      isLoading.value = false;
    });
};

/** 元画面へ遷移 */
const goBack = () => {
  if (store.getters.Flg === "Inquiry") {
    store.dispatch("setShowPage", "UserInquiryByUserID");
  } else {
    store.dispatch("setShowPage", "UserInquiryByDestination");
  }
};

/** 成り代わりログインの処理 */
const goAltLogin = () => {
  alertMessage.value = "null";
  alertState.value = "neutral";
  /* 成り代わりログインのログを登録する */
  const param = {
    loginUserId: store.getters.cognitoUserName,
    controlNumber: store.getters.loginNumber,
    targetUserId: userinfoList[0].userId,
    targetUserStation: userinfoList[0].stationcode,
    loginState: "login"
  }
  UserInfoDataService.insertAlternativeLogin(param)
    .then((_) => {
      isLoading.value = false;
      store.dispatch("setFirstMostUserData");
      store.dispatch("setIsAltLogin", true);
      store.dispatch("setUsername", userinfoList[0].userId);
      store.dispatch("setShowPage", "/");
      store.dispatch("setSubMenuList", null);
    })
    .catch((e: Error) => {
      console.log(e);
      if(e.response.data.dbException != undefined){
        const firstError = e.response.data.dbException[0];
        alertMessage.value = i18n.t("err081") + i18n.t("err080").replace("errorMessageValue", firstError.message);
      }else {
        alertMessage.value = i18n.t("err081") + i18n.t("err080").replace("errorMessageValue", e.response.data.message);
      }
      alertState.value = "error";
      isLoading.value = false;
    });
};

const inputDataCheck = () => {
  var isInputOk = true;
  //[E-mail]のチェック
  if (targetEmail.value.trim() == "") {
    emailError.value = i18n.t("alt021");
    isInputOk = false;
  }
  else if (!validEmail(targetEmail.value)) {
    emailError.value = i18n.t("alt022");
    isInputOk = false;
  }
  else {
    emailError.value = "";
    isInputOk = true;
  }
  return isInputOk;
}

const validEmail = (email) => {
  var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

const updateUserInfo = () => {
  if (inputDataCheck()) {
    alertMessage.value = "null";
    alertState.value = "neutral";
    isLoading.value = true;
    const data = {
      userId: userinfoList[0].userId,
      stationCode: targetStationCode.value,
      email: targetEmail.value,
      targetScreen: "UserMaintenanceUpdate",
      loginUserId: store.getters.cognitoUserName
    };
    UserInfoDataService.UpdateUserInfo(data)
      .then((response: ResponseData) => {
        if (response.data.message != undefined) {
          alertMessage.value = response.data.message;
          alertState.value = "error";
          isLoading.value = false;
        } else {
          userinfoList[0].updatedDate = new Date().toLocaleString('sv-SE').replace('T', ' ').replace(/-/g, '/');
          const cscfileData1 = {
            actionFlg: "",
            userID: userinfoList[0].userId,
            LName: userinfoList[0].familyName,
            FName: userinfoList[0].givenName,
            employeeID: userinfoList[0].employeeNumber,
            mail: targetEmail.value,
            companyName: userinfoList[0].companyName,
            stationCode: targetStationCode.value,
          };
          cscfileData1.actionFlg = response.data.authSendFlg == "1" ? "2,5" : "";
          if (cscfileData1.actionFlg != "") {
            UserInfoDataService.send_authenticationID(cscfileData1)
              .then((_) => {
                // 検索状態のまま表示するように修正 start
                var searchUserList = [];
                for(let userObj of store.getters.searchedUserList){
                  if(userObj.userId != userinfoList[0].userId){
                    searchUserList.push(userObj);
                  }else{
                    if(userObj.stationcode == targetStationCode.value){
                      userObj.email = targetEmail.value;
                      searchUserList.push(userObj);
                    }
                  }
                }
                store.dispatch("setSearchedUserList",searchUserList);
                // 検索状態のまま表示するように修正 end
                alertMessage.value = i18n.t("suc037");
                alertState.value = "success";
                isLoading.value = false;
              })
              .catch((e: Error) => {
                alertMessage.value = i18n.t("err063");
                alertState.value = "error";
                console.log(e);
                isLoading.value = false;
              });
          } else {
            // 検索状態のまま表示するように修正 start
            var searchUserList = [];
            for(let userObj of store.getters.searchedUserList){
              if(userObj.userId != userinfoList[0].userId){
                searchUserList.push(userObj);
              }else{
                if(userObj.stationcode == targetStationCode.value){
                  userObj.email = targetEmail.value;
                  searchUserList.push(userObj);
                }
              }
            }
            store.dispatch("setSearchedUserList",searchUserList);
            // 検索状態のまま表示するように修正 end
            alertMessage.value = i18n.t("suc037");
            alertState.value = "success";
            isLoading.value = false;
          }
        }
      })
      .catch((e: Error) => {
        alertMessage.value = e.message;
        alertState.value = "error";
        isLoading.value = false;
        console.log(e);
      });
  }
}

onUpdated(function () {
  isLoading.value = false;
});

const __returned__ = { isLoading, alertMessage, alertState, i18n, title, userId, userinfoList, destinationList, targetStationCode, targetEmail, emailError, isAuthForLogin, getUserInformation, goBack, goAltLogin, inputDataCheck, validEmail, updateUserInfo, UserNavigation, Loading, Alert, store }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})